/*
 * Generated from spec/surface.schema.json by ui/scripts/surface-schema.ts. Do not edit.
 *
 * Regenerate with `bun scripts/surface-schema.ts --write` from `ui/`.
 */

import type { JsonSchema } from '../client/surface-validate.js';

export const SURFACE_SCHEMA: JsonSchema = {
  "type": "object",
  "properties": {
    "algebra": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/AlgebraRow"
      }
    },
    "attestations": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/AttestationRow"
      }
    },
    "authorities": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/AuthorityStatus"
      }
    },
    "canonical": {
      "$ref": "#/$defs/CanonicalSummary"
    },
    "certificates": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/CertificateRow"
      }
    },
    "clock": {
      "$ref": "#/$defs/ClockSummary"
    },
    "context_runtimes": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/ContextRuntimeSummaryRow"
      }
    },
    "counts": {
      "$ref": "#/$defs/SurfaceCounts"
    },
    "fabric_runs": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/FabricRunRow"
      }
    },
    "generated_at_unix": {
      "type": "integer",
      "format": "uint64",
      "minimum": 0
    },
    "graph": {
      "$ref": "#/$defs/SurfaceGraph"
    },
    "hydrogen_revision": {
      "type": "string"
    },
    "not_projected": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/NotProjected"
      }
    },
    "oracles": {
      "$ref": "#/$defs/OracleSummary"
    },
    "pipeline": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/PipelineStage"
      }
    },
    "product": {
      "type": "string"
    },
    "protocol": {
      "type": "integer",
      "format": "uint32",
      "minimum": 0
    },
    "recent_changes": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/ChangeRow"
      }
    },
    "recent_events": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/EventRow"
      }
    },
    "recent_evidence": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/EvidenceRow"
      }
    },
    "states": {
      "type": "array",
      "items": {
        "$ref": "#/$defs/StateRow"
      }
    }
  },
  "required": [
    "protocol",
    "generated_at_unix",
    "product",
    "hydrogen_revision",
    "canonical",
    "counts",
    "oracles",
    "pipeline",
    "graph",
    "recent_changes",
    "context_runtimes",
    "recent_evidence",
    "recent_events",
    "authorities",
    "not_projected",
    "certificates",
    "algebra",
    "fabric_runs",
    "attestations",
    "states",
    "clock"
  ],
  "$defs": {
    "AlgebraRow": {
      "type": "object",
      "properties": {
        "left": {
          "type": "string"
        },
        "relation": {
          "type": "string"
        },
        "right": {
          "type": "string"
        }
      },
      "required": [
        "left",
        "right",
        "relation"
      ]
    },
    "AttestationRow": {
      "type": "object",
      "properties": {
        "digest": {
          "type": "string"
        },
        "epoch": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "oracle": {
          "type": "string"
        },
        "oracle_version": {
          "type": "string"
        },
        "reads": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "subject": {
          "type": "string"
        },
        "writes": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "digest",
        "subject",
        "oracle",
        "oracle_version",
        "epoch",
        "reads",
        "writes"
      ]
    },
    "AuthorityStatus": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "role": {
          "type": "string"
        },
        "status": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "role",
        "status"
      ]
    },
    "CanonicalSummary": {
      "type": "object",
      "properties": {
        "accepted_change_count": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "certificate_digest": {
          "type": [
            "string",
            "null"
          ]
        },
        "certificate_epoch": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "file_count": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "frontier": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/FrontierPoint"
          }
        },
        "frontier_digest": {
          "type": [
            "string",
            "null"
          ]
        },
        "state_root": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "required": [
        "frontier",
        "certificate_epoch",
        "accepted_change_count",
        "file_count"
      ]
    },
    "CertificateRow": {
      "type": "object",
      "properties": {
        "accepted_count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "base_state": {
          "type": "string"
        },
        "changes": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "digest": {
          "type": "string"
        },
        "epoch": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "evidence_root": {
          "type": "string"
        },
        "executed_engine_commit": {
          "type": [
            "string",
            "null"
          ]
        },
        "policy_digest": {
          "type": "string"
        },
        "prior_history_root": {
          "type": "string"
        },
        "result_history_root": {
          "type": "string"
        },
        "result_state": {
          "type": "string"
        }
      },
      "required": [
        "digest",
        "base_state",
        "result_state",
        "evidence_root",
        "policy_digest",
        "prior_history_root",
        "result_history_root",
        "epoch",
        "accepted_count",
        "changes"
      ]
    },
    "ChangeRow": {
      "type": "object",
      "properties": {
        "base_state": {
          "type": "string"
        },
        "claims": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "consequence": {
          "type": "string"
        },
        "dependencies": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "id": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "mutation_count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "observed_at_unix": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "policy_context": {
          "type": "string"
        },
        "producer": {
          "type": "string"
        },
        "projection": {
          "anyOf": [
            {
              "$ref": "#/$defs/GitProjectionRow"
            },
            {
              "type": "null"
            }
          ]
        },
        "reads": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "semantic": {
          "type": "boolean"
        },
        "writes": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "id",
        "producer",
        "intent",
        "base_state",
        "mutation_count",
        "semantic",
        "policy_context",
        "consequence",
        "reads",
        "writes",
        "claims",
        "dependencies",
        "observed_at_unix"
      ]
    },
    "ClockSummary": {
      "type": "object",
      "properties": {
        "authoritative": {
          "type": "boolean"
        },
        "fabric_bytes_read": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "fabric_bytes_written": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "first_observed_unix": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "last_observed_unix": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "latest_epoch": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "observed_subjects": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "total_run_duration_ms": {
          "$ref": "#/$defs/Measured_for_uint64"
        }
      },
      "required": [
        "latest_epoch",
        "observed_subjects",
        "first_observed_unix",
        "last_observed_unix",
        "total_run_duration_ms",
        "fabric_bytes_read",
        "fabric_bytes_written",
        "authoritative"
      ]
    },
    "ContextRuntimeSummaryRow": {
      "type": "object",
      "properties": {
        "basis_digest": {
          "type": "string"
        },
        "cacheable_prefix_bps": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "cone_receipt_digest": {
          "type": "string"
        },
        "decision": {
          "type": "string"
        },
        "deferred_handles": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "deferred_tokens": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "input_digest": {
          "type": "string"
        },
        "instruction_diagnostics": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "matched_agent_traces": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "model_identity": {
          "type": "string"
        },
        "plan_cache_hit": {
          "type": "boolean"
        },
        "playbook_recommendation": {
          "$ref": "#/$defs/PlaybookRecommendation"
        },
        "receipt_digest": {
          "type": "string"
        },
        "resident_handles": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "resident_tokens": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        }
      },
      "required": [
        "receipt_digest",
        "cone_receipt_digest",
        "input_digest",
        "basis_digest",
        "model_identity",
        "decision",
        "resident_handles",
        "deferred_handles",
        "resident_tokens",
        "deferred_tokens",
        "cacheable_prefix_bps",
        "matched_agent_traces",
        "plan_cache_hit",
        "playbook_recommendation",
        "instruction_diagnostics"
      ]
    },
    "EdgeKind": {
      "oneOf": [
        {
          "type": "string",
          "const": "base"
        },
        {
          "type": "string",
          "const": "result"
        }
      ]
    },
    "EventRow": {
      "type": "object",
      "properties": {
        "kind": {
          "type": "string"
        },
        "subject": {
          "type": "string"
        },
        "summary": {
          "type": "string"
        }
      },
      "required": [
        "kind",
        "subject",
        "summary"
      ]
    },
    "EvidenceRow": {
      "type": "object",
      "properties": {
        "artifact_digest": {
          "type": [
            "string",
            "null"
          ]
        },
        "claim": {
          "type": "string"
        },
        "dependencies": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "digest": {
          "type": "string"
        },
        "epoch": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "oracle": {
          "type": "string"
        },
        "oracle_version": {
          "type": "string"
        },
        "subject": {
          "type": "string"
        },
        "verdict": {
          "$ref": "#/$defs/Verdict"
        }
      },
      "required": [
        "digest",
        "subject",
        "claim",
        "verdict",
        "oracle",
        "oracle_version",
        "epoch",
        "dependencies"
      ]
    },
    "FabricOutcomeRow": {
      "type": "object",
      "properties": {
        "action": {
          "type": "string"
        },
        "claim": {
          "type": "string"
        },
        "class": {
          "type": "string"
        },
        "evidence_digest": {
          "type": "string"
        },
        "exit_code": {
          "$ref": "#/$defs/Measured_for_int64"
        },
        "oracle": {
          "type": "string"
        },
        "reused": {
          "type": "boolean"
        },
        "subject": {
          "type": "string"
        },
        "verdict": {
          "$ref": "#/$defs/Verdict"
        }
      },
      "required": [
        "claim",
        "oracle",
        "verdict",
        "class",
        "action",
        "subject",
        "evidence_digest",
        "exit_code",
        "reused"
      ]
    },
    "FabricRunRow": {
      "type": "object",
      "properties": {
        "change_id": {
          "type": "string"
        },
        "decision": {
          "type": "string"
        },
        "digest": {
          "type": "string"
        },
        "duration_ms": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "epoch": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "executed": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "history_continued": {
          "type": "boolean"
        },
        "observed_at_unix": {
          "$ref": "#/$defs/Measured_for_uint64"
        },
        "outcomes": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/FabricOutcomeRow"
          }
        },
        "reused": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "usage_passed": {
          "type": "boolean"
        }
      },
      "required": [
        "digest",
        "change_id",
        "decision",
        "usage_passed",
        "history_continued",
        "reused",
        "executed",
        "epoch",
        "outcomes",
        "observed_at_unix",
        "duration_ms"
      ]
    },
    "FrontierPoint": {
      "type": "object",
      "properties": {
        "accepted_change_count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "certificate_digest": {
          "type": "string"
        },
        "epoch": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "file_count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "state_root": {
          "type": "string"
        }
      },
      "required": [
        "state_root",
        "certificate_digest",
        "epoch",
        "accepted_change_count",
        "file_count"
      ]
    },
    "GitProjectionRow": {
      "type": "object",
      "properties": {
        "parent_commit": {
          "type": "string"
        },
        "parent_tree": {
          "type": "string"
        },
        "source_commit": {
          "type": "string"
        },
        "source_tree": {
          "type": "string"
        }
      },
      "required": [
        "source_commit",
        "source_tree",
        "parent_commit",
        "parent_tree"
      ]
    },
    "GraphEdge": {
      "type": "object",
      "properties": {
        "from": {
          "type": "string"
        },
        "kind": {
          "$ref": "#/$defs/EdgeKind"
        },
        "to": {
          "type": "string"
        }
      },
      "required": [
        "from",
        "to",
        "kind"
      ]
    },
    "GraphNode": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "kind": {
          "$ref": "#/$defs/NodeKind"
        },
        "label": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "kind",
        "label"
      ]
    },
    "Measured_for_int64": {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "measured": {
              "type": "string",
              "const": "yes"
            },
            "value": {
              "type": "integer",
              "format": "int64"
            }
          },
          "required": [
            "measured",
            "value"
          ]
        },
        {
          "type": "object",
          "properties": {
            "measured": {
              "type": "string",
              "const": "no"
            },
            "refusal": {
              "type": "string"
            }
          },
          "required": [
            "measured",
            "refusal"
          ]
        }
      ]
    },
    "Measured_for_uint64": {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "measured": {
              "type": "string",
              "const": "yes"
            },
            "value": {
              "type": "integer",
              "format": "uint64",
              "minimum": 0
            }
          },
          "required": [
            "measured",
            "value"
          ]
        },
        {
          "type": "object",
          "properties": {
            "measured": {
              "type": "string",
              "const": "no"
            },
            "refusal": {
              "type": "string"
            }
          },
          "required": [
            "measured",
            "refusal"
          ]
        }
      ]
    },
    "NodeKind": {
      "oneOf": [
        {
          "type": "string",
          "const": "state"
        },
        {
          "type": "string",
          "const": "certificate"
        }
      ]
    },
    "NotProjected": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "reason": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "reason"
      ]
    },
    "OracleSummary": {
      "type": "object",
      "properties": {
        "fail": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "pass": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        }
      },
      "required": [
        "pass",
        "fail"
      ]
    },
    "PipelineStage": {
      "type": "object",
      "properties": {
        "count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "id": {
          "type": "string"
        },
        "projected": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "count",
        "projected"
      ]
    },
    "PlaybookRecommendation": {
      "type": "string",
      "enum": [
        "apply",
        "hold",
        "reject"
      ]
    },
    "StateRow": {
      "type": "object",
      "properties": {
        "file_count": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "history_root": {
          "type": [
            "string",
            "null"
          ]
        },
        "root": {
          "type": "string"
        }
      },
      "required": [
        "root",
        "file_count"
      ]
    },
    "SurfaceCounts": {
      "type": "object",
      "properties": {
        "certificates": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "changes": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "evidence": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "states": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        },
        "unique_producers": {
          "type": "integer",
          "format": "uint64",
          "minimum": 0
        }
      },
      "required": [
        "changes",
        "evidence",
        "certificates",
        "states",
        "unique_producers"
      ]
    },
    "SurfaceGraph": {
      "type": "object",
      "properties": {
        "edges": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/GraphEdge"
          }
        },
        "nodes": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/GraphNode"
          }
        }
      },
      "required": [
        "nodes",
        "edges"
      ]
    },
    "Verdict": {
      "type": "string",
      "enum": [
        "pass",
        "fail"
      ]
    }
  }
};
